import React from 'react';
import $ from 'jquery';

import AudiencesComponent from './components/AudiencesComponent.jsx';
import LoadingComponent from '../../shared/LoadingComponent';
import AudienceApi from './AudienceApi';

import {
  Fetcher,
  WindowHelper,
  LocalStorer,
  InfiniScroller,
} from '../../lib/helpers';
import { AiRouter } from '../../lib/utils';

class Explore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAudience: {},
      loading: true,
      scrollLoading: false,
      audiences: [],
      winWidth: 0,
      winHeight: 0,
    };
    this.audienceRedirect = this.audienceRedirect.bind(this);
    this.getAudienceTiles = this.getAudienceTiles.bind(this);
    this.navbarRedirect = this.navbarRedirect.bind(this);
    this.copyTile = this.copyTile.bind(this);
    this.copyAllTiles = this.copyAllTiles.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.getAllAudiences = this.getAllAudiences.bind(this);
    this.updateActiveDisplay = this.updateActiveDisplay.bind(this);
    this.populateAudiences = this.populateAudiences.bind(this);
    this.getAdditionalTiles = this.getAdditionalTiles.bind(this);
    this.openTileModal = this.openTileModal.bind(this);
    this.validLocalStorage = this.validLocalStorage.bind(this);
    this.hasUpdatedAtOnStorage = this.hasUpdatedAtOnStorage.bind(this);
    this.copyToBoard = this.copyToBoard.bind(this);
    this.scrollState = new InfiniScroller({
      scrollPercentage: 0.9,
      throttle: 100,
      onScroll: this.getAdditionalTiles,
    });
  }

  componentDidMount() {
    this.populateAudiences().then(() => this.updateActiveDisplay());
    this.updateDimensions();
    this.scrollState.setOnScroll();
    this.props.setUser({
      isGuestUser: this.props.ctrl.isGuestUser,
      isEndUser: this.props.ctrl.isEndUser,
    });
    window.addEventListener('resize', this.updateDimensions);
    window.addEventListener('popstate', this.updateActiveDisplay);
  }

  componentWillUnmount() {
    this.scrollState.removeOnScroll();
    window.removeEventListener('resize', this.updateDimensions);
    window.removeEventListener('popstate', this.updateActiveDisplay);
  }

  updateActiveDisplay() {
    const splitRoute = AiRouter.currentUrl().split('/');
    const audienceId = [...splitRoute].pop();
    if (audienceId === 'explore' && splitRoute.length < 3) {
      this.setState({
        selectedAudience: {},
      });
    } else {
      const camp = AudienceApi.findBy(
        this.state.audiences,
        'path',
        `audiences/${audienceId}`,
      );
      if (camp) {
        this.audienceRedirect(camp, 'popstate');
      } else {
        AiRouter.pathNotFound();
      }
    }
  }

  getAdditionalTiles() {
    const camp = this.state.selectedAudience;
    if (
      !this.state.scrollLoading &&
      camp &&
      !!this.state[`tilePageLoaded${camp.id}`]
    ) {
      this.setState({ scrollLoading: true });
      this.getAudienceTiles(this.state.selectedAudience);
    }
  }

  updateDimensions() {
    const newDimensions = WindowHelper.getDimensions();
    this.setState(newDimensions);
  }

  navbarRedirect(e) {
    e.preventDefault();
    AiRouter.navigation('explore');
    this.setState({
      selectedAudience: {},
    });
  }

  audienceRedirect(audience, popstate) {
    if (!popstate) {
      window.Airbo.Utils.ping('Explore page - Interaction', {
        action: 'Clicked Audience',
        audience: audience.name,
        audienceId: audience.id,
      });
      AiRouter.navigation(audience.path, { appendToCurrentUrl: true });
    }
    if (!this.state[`audienceTiles${audience.id}`]) {
      this.getAudienceTiles(audience, { loading: true });
    } else {
      this.setState({ selectedAudience: audience });
    }
  }

  // Forgive me gods of the codes.
  // This verification is needed, to force a invalidation of our local storage
  // Once the ticket AIR-1543 is deployed
  // This will be needed until we remove localstorage from the equation

  hasUpdatedAtOnStorage(audienceDataStorage) {
    const firstAudienceUuid = audienceDataStorage.audiences[0].id;

    return !!audienceDataStorage[`audienceTiles${firstAudienceUuid}`][0]
      .updatedAt;
  }

  validLocalStorage(storage) {
    const latestTileIsTheSame =
      storage.latestTile && storage.latestTile === this.props.ctrl.latestTile;
    const currentBoardIsTheSame =
      !!storage.currentBoard &&
      storage.currentBoard === this.props.ctrl.currentBoard;

    return (
      latestTileIsTheSame &&
      currentBoardIsTheSame &&
      this.hasUpdatedAtOnStorage(storage['audience-data'])
    );
  }

  populateAudiences() {
    const storage = LocalStorer.getAll([
      'latestTile',
      'currentBoard',
      'audience-data',
    ]);

    return new Promise(resolve => {
      if (this.validLocalStorage(storage)) {
        this.setState(storage['audience-data']);
        resolve();
      } else {
        this.getAllAudiences(resolve);
      }
    });
  }

  getAllAudiences(callback) {
    AudienceApi.getAll(this.props.ctrl.currentBoard, response => {
      const initAudienceState = {
        audiences: [],
        loading: false,
      };
      response.forEach(resp => {
        initAudienceState[`tilePageLoaded${resp.id}`] =
          resp.tiles.length < 26 ? 0 : 1;
        initAudienceState.audiences.push(
          AudienceApi.sanitizeAudienceResponse(resp),
        );
        initAudienceState[`audienceTiles${resp.id}`] = resp.tiles;
      });
      this.setState(initAudienceState);
      LocalStorer.setAll({
        'audience-data': JSON.stringify(initAudienceState),
        latestTile: this.props.ctrl.latestTile,
        currentBoard: this.props.ctrl.currentBoard,
      });
      if (callback) {
        callback();
      }
    });
  }

  getAudienceTiles(audience, opts) {
    const page = this.state[`tilePageLoaded${audience.id}`] + 1;
    this.setState(opts);
    Fetcher.get(
      `/api/client_admin/explore/audiences/${audience.id}?page=${page}`,
      response => {
        const newState = {
          selectedAudience: audience,
          loading: false,
          scrollLoading: false,
        };
        newState[`tilePageLoaded${audience.id}`] =
          response.length < 26 ? 0 : page;
        newState[`audienceTiles${audience.id}`] = (
          this.state[`audienceTiles${audience.id}`] || []
        ).concat(response);
        this.setState(newState);
      },
    );
  }

  copyToBoard = (copyPath, $tile, successCb) => {
    Fetcher.xmlHttpRequest({
      path: copyPath,
      success: () => {
        successCb($tile);
      },
      err: err => {
        console.error(err, 'Something went wrong');
      },
    });
  };

  copyTile(data) {
    return new Promise(resolve => {
      const $tile = $(`#${data.id}`);
      $tile.text('Copying...');
      this.copyToBoard(data.copyPath, $tile, self => {
        self.text('Copied');
        window.Airbo.ExploreKpis.copyTilePing(self, 'thumbnail');
        resolve();
      });
    });
  }

  async copyAllTiles(e) {
    e.preventDefault();
    const $target = $(e.target);
    window.Airbo.ExploreKpis.copyAllTilesPing($target);
    window.Airbo.Utils.ping('Tile Viewed - Explore', {
      action: 'Copied Campaign',
      audienceName: this.state.selectedAudience.name,
    });
    this.setState({
      selectedAudience: {
        ...this.state.selectedAudience,
        copyText: 'Copying...',
      },
    });

    let initialIndex =
      this.state[`audienceTiles${this.state.selectedAudience.id}`].length - 1;

    for (initialIndex; initialIndex >= 0; initialIndex--) {
      await this.copyTile(
        this.state[`audienceTiles${this.state.selectedAudience.id}`][
          initialIndex
        ],
      );
    }

    this.setState({
      selectedAudience: {
        ...this.state.selectedAudience,
        copyText: 'Campaign Copied',
      },
    });
    $target.addClass('disabled green');
  }

  openTileModal(tileId) {
    this.props.setTiles({
      explore: [
        ...this.state[`audienceTiles${this.state.selectedAudience.id}`],
      ],
    });
    this.props.openFullSizeTile({
      id: tileId,
      from: 'explore',
      tileActions: {
        copyTile: this.copyTile,
      },
    });
  }

  render() {
    return (
      <div>
        {this.state.loading ? (
          <LoadingComponent />
        ) : (
          <AudiencesComponent
            {...this.state}
            audienceRedirect={this.audienceRedirect}
            navbarRedirect={this.navbarRedirect}
            copyTile={this.copyTile}
            copyAllTiles={this.copyAllTiles}
            user={this.props.ctrl}
            openTileModal={this.openTileModal}
          />
        )}
      </div>
    );
  }
}

export default Explore;
